import { useEffect, useState } from "react";
import { Clock, ExternalLink, Sparkles, UtensilsCrossed } from "lucide-react";
import { DishList, VegLegend } from "@/components/DishList";
import { api } from "@/lib/api";

export const PropertyFoodMenu = ({ propertyId }) => {
  const [menu, setMenu] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get(`/public/properties/${propertyId}/food-menu`)
      .then((r) => alive && setMenu(r.data))
      .catch((err) => {
        if (alive && err?.response?.status !== 404) console.warn("food menu load failed", err);
        if (alive) setMenu(null);
      });
    return () => {
      alive = false;
    };
  }, [propertyId]);

  if (!menu) return null;
  const today = menu.week.find((d) => d.is_today);

  return (
    <div className="py-7 border-b border-border" data-testid="property-food-menu">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <h3 className="flex items-center gap-2 font-display text-lg">
          <UtensilsCrossed className="h-4 w-4 text-primary" /> Food served here
        </h3>
        <a
          href={menu.public_url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-[12px] font-bold hover:underline"
          data-testid="property-food-menu-full-link"
        >
          See the full week <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>

      {menu.special_today && (
        <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2 text-[12px] font-bold text-primary" data-testid="property-food-special-today">
          <Sparkles className="h-3.5 w-3.5" /> Today: {menu.special_today}
        </p>
      )}

      <p className="mt-3 text-[12px] font-semibold text-muted-foreground">Today · {today?.label}</p>
      <div className="mt-3 grid gap-4 sm:grid-cols-2">
        {today?.meals.map((m) => (
          <div key={m.key} className="rounded-xl bg-muted/60 p-4" data-testid={`property-food-meal-${m.key}`}>
            <p className="flex items-center justify-between gap-2 text-sm font-bold">
              {m.name}
              {m.time && (
                <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-muted-foreground">
                  <Clock className="h-3 w-3" /> {m.time}
                </span>
              )}
            </p>
            <div className="mt-2">
              <DishList dishes={m.dishes} items={m.items} testid={`property-food-dishes-${m.key}`} />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4">
        <VegLegend />
      </div>
    </div>
  );
};
